/* import __COLOCATED_TEMPLATE__ from './headers.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

export default class Headers extends Component {
  @service store;
  @service router;
  @service intl;
  @service appService;

  @tracked isAddingAuthHeader;

  constructor() {
    super(...arguments);
  }

  get isActionClass() {
    return this.args.headerClass === 'workflow-connector/action-header';
  }

  get isAuthClass() {
    return this.args.headerClass === 'custom-authentication/refresh-token-configuration-header';
  }

  get tokenFooterActions() {
    return [
      {
        text: this.intl.t('workflow-connector.builder.body.request.tabs.authentication.new-label'),
        icon: 'new',
        action: () =>
          safeWindowOpen(this.router.urlFor('apps.app.settings.app-settings.authentication.new')),
      },
      {
        text: this.intl.t(
          'workflow-connector.builder.body.request.tabs.authentication.manage-tokens',
        ),
        icon: 'settings',
        action: () =>
          safeWindowOpen(this.router.urlFor('apps.app.settings.app-settings.authentication')),
      },
    ];
  }

  get addHeaderList() {
    return [
      {
        items: [
          {
            text: this.intl.t('workflow-connector.builder.body.request.key-value'),
            onSelectItem: () => this.addHeader(),
          },
          {
            text: this.intl.t('workflow-connector.builder.body.request.auth-token'),
            onSelectItem: () => this.startAddingAuthHeader(),
          },
        ],
      },
    ];
  }

  get showAuthHeader() {
    return isPresent(this.args.selectedToken) || this.isAddingAuthHeader;
  }

  get showIntercomVerifiedEmailHeader() {
    return this.args.headerObject.otpAuthEnabled;
  }

  get readonly() {
    return this.isStripeTokenSelected;
  }

  get isStripeTokenSelected() {
    return this.args.selectedToken?.createdBy === 'created_by_stripe_integration';
  }

  @action
  onTokenSelected(token) {
    this.args.updateWorkflowToken(token);
    if (this.isStripeTokenSelected) {
      this.args.headerObject.headers.clear();
    }
  }

  @action
  addHeader() {
    this.args.headerObject.headers.pushObject(
      this.store.createFragment(this.args.headerClass, {
        name: '',
        value: '',
      }),
    );
  }

  @action
  startAddingAuthHeader() {
    this.isAddingAuthHeader = true;
  }

  @action
  clearSelectedToken() {
    this.isAddingAuthHeader = false;
    this.args.clearSelectedToken();
  }

  @action
  deleteHeader(headerNameValue) {
    this.args.headerObject.headers.removeFragment(headerNameValue);
  }
}
